/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import { exportSoapAsFhir } from '@/lib/sprint5';

/** Esporta la nota SOAP come Bundle FHIR R4 e avvia il download del file JSON. */
export const downloadFhirBundle = async (appt, soap) => {
  const now = new Date().toISOString();
  const res = await exportSoapAsFhir({
    appointment_id: appt.id, patient_id: appt.patient_id, ...soap, language: 'it',
    started_at: now, ended_at: now,
  });
  const blob = new Blob([JSON.stringify(res, null, 2)], { type: 'application/fhir+json' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob); a.download = `encounter-${appt.id}.fhir.json`; a.click();
  URL.revokeObjectURL(a.href);
  return res;
};

/** Testo da accodare alla trascrizione quando si importa il triage AI pre-visita. */
export const triageToTranscript = (prev, triage) =>
  `${prev}${prev ? ' ' : ''}Paziente riferisce: ${triage.symptoms || ''}${triage.duration ? ` da ${triage.duration}` : ''}.`;
